import styled from 'styled-components';
import {dFlex, dInlineFlex, justifyBetween, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {WHITE, GRAY, LIGHT_GRAY3, HOVER_BLUE, BGImageCenter, mobileMedia, BORDER_GRAY, desktopMedia} from '../../../../../../globalVariables/GlobalVariables';
import {arrowDown} from '../../../../../../assets/symbols/symbols/Symbols.css';
import {wrapper} from '../../../../../components/smartSearchOnList/SmartSearchOnList.css';

export const searchSection = styled.div`
    ${dFlex}
    padding: 15px 40px;
    gap: 15px;
    ${alignCenter}
    ${wrapper}{
        ${desktopMedia}{
            inset-inline-end: 30px;
        }
        height: 36px;
    }
    ${mobileMedia}{
        padding: 10px;
    }
`;

export const searchIcon = styled.span`
    margin-inline-end: 8px;
    color: ${GRAY};
`;

export const filterDropdowns = styled.div`
    ${dFlex}
    gap: 10px;
    ${alignCenter}
    position: relative;
`;

export const filterSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid ${LIGHT_GRAY3};
    border-radius: 6px;
    background: ${WHITE};
    min-width: 120px;
    
    &:focus {
        outline: none;
        border-color: ${HOVER_BLUE};
    }
`;

export const filterButton = styled.button`
    ${dInlineFlex}
    padding: 8px 16px;
    ${justifyBetween}
    ${alignCenter}
    gap: 8px;
    border-radius: 200px;
    border: 0.5px solid ${BORDER_GRAY};
    background: ${WHITE};
    min-width: 120px;
    cursor: pointer;
    text-align: start;
    
    &:hover {
        border-color: ${HOVER_BLUE};
    }
    
    &:focus {
        outline: none;
        border-color: ${HOVER_BLUE};
    }
    
    &::after {
        content: '';
        height: 15px;
        width: 15px;
        ${BGImageCenter(arrowDown)} 
    }   
`;

export const filterIcon = styled.span`
    font-size: 18px;
    color: ${GRAY};
    cursor: pointer;
`;
